module.exports = __webpack_public_path__ + "f0b22d92aaa6f2849913010af0569106.jpg";